// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2_hv4","title":"AfterFrontImage_title__3Dynj"};